<template>
  <page-section :title="title" class="techSheet">
    <slot name="intro">
    </slot>
    <div class="row">
      <div class="col-md-4 col-md-offset-0 col-sm-offset-2 col-sm-8"
           v-for="m in list" :key="`list-${m.key}`">
        <div class="panel"
             :class="`panel-${m.type == null ? 'techSheet' : m.type}`">
            <div class="panel-heading text-center">
              <h2 class="panel-title" v-html="m.title"></h2>
            </div>
            <div class="panel-body">
              <ul>
                <div v-for="(l, k) in m.sections"
                     :key="`${m.key}-${k}`">
                  <hr v-if="k > 0">
                  <h3 :class="`txt-${l.type} text-center`">
                    {{ l.title }}
                  </h3>
                  <link-block v-for="(li, j) in l.links"
                              :key="`${m.key}-${k}-${j}`"
                              :file="li.file"
                              :link="li.link"
                              :description="li.description"
                              :class="`fb-${l.type}`"
                              :title="li.title"
                              :text="li.text"
                              :icon="li.icon">
                  </link-block>
                </div>
              </ul>
            </div>
        </div>
      </div>
    </div>
  </page-section>
</template>
<script>
import pageSection from '@/components/pagesection'
import linkBlock from '@/components/linkBlock'

export default {
  name: 'techSheets',

  props: {
    title: {
      type: String,
      required: true
    },

    list: {
      type: Array,
      required: true
    },

    tools: {
      type: String
    }
  },

  components: {
    'page-section': pageSection,
    'link-block': linkBlock
  }
}
</script>
<style scoped lang="less">
ul {
  padding-left: 1rem;
  padding-right: 1rem;
}

h2.panel-title {
  font-size: 150%;
}

.panel-title {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 7rem;
}

h3:first-child {
  margin-top: 0rem;
}
</style>
